import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-100 mw-600px mx-auto mb-10" }
const _hoisted_2 = { class: "fv-row mb-10 text-start" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 fv-row mt-0"
}
const _hoisted_4 = { class: "fv-plugins-message-container text-start" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = {
  key: 1,
  class: "col-md-12 fv-row mt-2"
}
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "my-2" }, "Label", -1)
const _hoisted_9 = {
  key: 2,
  class: "col-md-12 fv-row mt-2"
}
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "my-2" }, "Direction", -1)
const _hoisted_12 = {
  key: 3,
  class: "col-md-12 fv-row mt-2"
}
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "my-2" }, "Label and Value", -1)
const _hoisted_15 = { id: "basic-addon2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-white m-1 fs-4" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  id: "basic-addon2"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-white m-1 fs-4" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  tabindex: "0",
  class: "min-w-90px btn btn-outline btn-outline-primary btn-active-light-primary"
}, " Confirm ", -1)


import {
  computed,
  defineComponent,
  defineProps,
  ref,
  defineEmits,
  watchEffect,
  toRef,
  watch,
} from "vue";
import VZModal from "@/components/content/VZModal.vue";
import { Field, Form, ErrorMessage, useResetForm } from "vee-validate";
import { IOptionModel } from "@/interfaces/iPageModel";
import * as Yup from "yup";
import { TranslationService } from "@/core/services/TranslationService";
import { getLookups } from "@/services/api/Lookup.service";
import {
  DroppableComponent,
  droppableControls,
  Component,
  ComponentDiretionOptions,
  ComponentDiretion,
  EComponentDiretion,
  getUniqueKey,
} from "../components/dynamicValidation";
import { v4 as uuidv4 } from "uuid";
const __default__ = defineComponent({
  name: "DropComponentModal",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    selectedComponent: null,
    sectionId: null,
    showDialog: { type: Boolean }
  },
  emits: {
  "create-element": (component: Component | Component[]) => {
    if (component) {
      return true;
    } else {
      return false;
    }
  },
  "on-modal-close": () => true,
},
  setup(__props: any, { emit }) {

const props = __props as {
  selectedComponent: DroppableComponent;
  sectionId: string;
  showDialog: boolean;
}

function t(key: string) {
  return TranslationService.translate(key);
}

const LKLookupOptions = ref<{ label: any; value: string }[]>([]);
const LookupName = ref<string>("");
const showDialog = toRef(props, "showDialog");
const direction = ref<ComponentDiretion>(EComponentDiretion.LEFT);
const labelText = ref<string>("");

const resetForm = useResetForm();
const options = ref<IOptionModel[]>([{ text: "", value: "" }]);
const validationSchema = computed(() => {
  if (props.selectedComponent === "LOOKUP") {
    return Yup.object({
      name: Yup.string().required(
        t("common.name") + " " + t("common.isRequired")
      ),
    });
  }

  return Yup.object({});
});
//computed
const modalTitle = computed(() => {
  return selectedDropableComponent.value?.label ?? props.selectedComponent;
});
const selectedDropableComponent = computed(() => {
  return (
    droppableControls.value.find(
      (item) => item.type === props.selectedComponent
    ) ?? null
  );
});

const onSubmit = (values, { resetForm }) => {
  const key = uuidv4();
  const linkedTo = uuidv4();
  const label = droppableControls.value.find(
    (item) => item.type === DroppableComponent.LABEL
  );

  // Handle cases where values.name is undefined
  let name = `${props.selectedComponent}_${getUniqueKey()}`; // Default name
  if (
    values.name &&
    ["LABEL", "LOOKUP", "PARAGRAPH", "DIVIDER"].includes(
      props.selectedComponent
    )
  ) {
    name = `${props.selectedComponent}_${values.name.replace(
      /[^A-Z0-9]+/gi,
      "_"
    )}_${getUniqueKey()}`;
  }

  // Special cases for LABEL and PARAGRAPH
  if (values.name === "" && props.selectedComponent === "LABEL") {
    values.name = "text";
    name = `${props.selectedComponent}_text_${getUniqueKey()}`;
  }
  if (values.name === "" && props.selectedComponent === "PARAGRAPH") {
    values.name = "paragraph";
    name = `${props.selectedComponent}_paragraph_${getUniqueKey()}`;
  }

  const isLinkable =
    (selectedDropableComponent.value?.isLinkable && values.labelText) ?? false;

  const labelComponent = {
    component: "LABEL",
    name: `LABEL_${values?.labelText?.replace(
      /[^A-Z0-9]+/gi,
      "_"
    )}_${getUniqueKey()}`,
    key: linkedTo,
    controlId: `LABEL_${props.sectionId}_${getUniqueKey()}`,
    attrs: {
      "v-on": "{drop:drop($event), dragover:allowDrop($event)}",
      class: label?.cssClass,
      label: values.labelText,
      id: linkedTo,
    },
  };

  if (["RADIO_BUTTON"].includes(props.selectedComponent)) {
    const emitter = options.value.map((option) => {
      const key2 = uuidv4();
      return {
        component: props.selectedComponent,
        name: name,
        key: key2,
        linkedLabelKey: isLinkable ? linkedTo : "",
        direction: direction.value,
        controlId: `RADIO_BUTTON_${props.sectionId}_${getUniqueKey()}`,
        attrs: {
          "v-on": "{drop:drop($event), dragover:allowDrop($event)}",
          class: selectedDropableComponent.value?.cssClass,
          label: option.text,
          value: option.value,
          id: key2,
        },
      };
    });
    emitEvent(emitter, labelComponent, isLinkable);
  }
  if (
    [
      "BUTTON",
      "RATING",
      "FILE",
      "ATTACHEMENTS",
      "TEXT_FIELD",
      "HIDDEN",
      "PASSWORD_FIELD",
      "TEXT_AREA",
      "LABEL",
      "PARAGRAPH",
      "SWITCH_BUTTON",
      "CHECK_BOX",
      "DIVIDER",
      "IMAGE",
      "DATE",
      "SIGNATURE",
      "TIMER",
      "CAMERA",
      "LOOKUP",
      "QR_VALIDATOR",
      "QR_CODE",
      "BAR_CODE",
      "BAR_VALIDATOR",
    ].includes(props.selectedComponent)
  ) {
    const emitter: Component = {
      component: props.selectedComponent,
      name: name,
      key,
      linkedLabelKey: isLinkable ? linkedTo : "",
      direction: direction.value,
      controlId: `${props.selectedComponent}_${
        props.sectionId
      }_${getUniqueKey()}`,
      attrs: {
        "v-on": "{drop:drop($event), dragover:allowDrop($event)}",
        class: selectedDropableComponent.value?.cssClass,
        label:
          values.name ||
          selectedDropableComponent.value?.label ||
          props.selectedComponent,
        id: key,
        defaultValue:
          selectedDropableComponent.value?.defaultValue == ""
            ? values.name || props.selectedComponent
            : selectedDropableComponent.value?.defaultValue,
      },
      defaultValue:
        props.selectedComponent === "PARAGRAPH" && values.name
          ? values.name
          : "",
    };
    emitEvent([emitter], labelComponent, isLinkable);
  }
  if (["LIST"].includes(props.selectedComponent)) {
    const emitter: Component = {
      component: props.selectedComponent,
      name: name,
      key,
      linkedLabelKey: isLinkable ? linkedTo : "",
      direction: direction.value,
      controlId: `LIST_${props.sectionId}_${getUniqueKey()}`,
      attrs: {
        "v-on": "{drop:drop($event), dragover:allowDrop($event)}",
        class: selectedDropableComponent.value?.cssClass,
        label:
          values.name ||
          selectedDropableComponent.value?.label ||
          props.selectedComponent,
        id: key,
      },
    };

    const optionAttr = options.value.map((option) => {
      return {
        text: option.text,
        value: option.value,
      };
    });
    emitter.attrs = { ...emitter.attrs, options: optionAttr };
    emitEvent([emitter], labelComponent, isLinkable);
  }
  resetForm();
};
const emitEvent = (
  component: Component | Component[],
  labelComponent,
  isLinkable
) => {
  if (isLinkable) {
    if (direction.value === EComponentDiretion.LEFT) {
      emit("create-element", [
        labelComponent,
        ...(Array.isArray(component) ? component : [component]),
      ]);
      onModalClose();
    } else {
      emit("create-element", [
        ...(Array.isArray(component) ? component : [component]),
        labelComponent,
      ]);
      onModalClose();
    }
  } else {
    emit("create-element", component);
    onModalClose();
  }
};
const fetchLookupOptions = async () => {
  const lookupURL = "static-data/filter/LOOKUP_NAME";
  getLookups(lookupURL)
    .then((res) => {
      if (res) {
        const lookupOptions = res.map((item) => {
          return {
            label: item.text,
            value: item.value,
          };
        });
        LKLookupOptions.value = lookupOptions;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
const onModalClose = () => {
  options.value = [{ text: "", value: "" }];
  direction.value = EComponentDiretion.LEFT;
  labelText.value = "";
  emit("on-modal-close");
};

watch(showDialog, () => {
  LookupName.value = "";
  resetForm();
});
watchEffect(() => {
  LKLookupOptions.value = [];
  if (props.selectedComponent === "LOOKUP") {
    fetchLookupOptions();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      ref: "dynamicForm",
      "validation-schema": _unref(validationSchema),
      onSubmit: onSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(VZModal, {
          title: `${_unref(modalTitle)} Settings`,
          id: "vz_drop_component_props",
          widthClass: 'width-550',
          showDialog: _unref(showDialog),
          onModalClose: _cache[8] || (_cache[8] = ($event: any) => (onModalClose()))
        }, {
          actions: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
              tabindex: "1",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (onModalClose()), ["stop"]))
            }, " Close "),
            _hoisted_24
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (
                ['LABEL', 'LOOKUP', 'PARAGRAPH', 'DIVIDER'].includes(
                  props.selectedComponent
                )
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["my-2 me-4", { required: props.selectedComponent === 'LOOKUP' }])
                      }, _toDisplayString(t("common.name")), 3),
                      (props.selectedComponent === 'LOOKUP')
                        ? (_openBlock(), _createBlock(_unref(Field), {
                            key: 0,
                            name: "name",
                            modelValue: LookupName.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((LookupName).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: LookupName.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((LookupName).value = $event)),
                                filterable: true,
                                placeholder: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(LKLookupOptions.value, (option, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: option.label,
                                      value: option.label
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (props.selectedComponent !== 'LOOKUP')
                        ? (_openBlock(), _createBlock(_unref(Field), {
                            key: 1,
                            type: "text",
                            name: "name",
                            placeholder: "",
                            autocomplete: "off",
                            class: "form-control",
                            modelValue: LookupName.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((LookupName).value = $event))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(ErrorMessage), { name: "name" })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(selectedDropableComponent)?.isLinkable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_unref(Field), {
                          type: "text",
                          name: "labelText",
                          placeholder: "",
                          autocomplete: "off",
                          class: "form-control",
                          modelValue: labelText.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((labelText).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(selectedDropableComponent)?.isLinkable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_unref(Field), {
                          type: "text",
                          name: "direction",
                          placeholder: "",
                          autocomplete: "off",
                          class: "form-control",
                          modelValue: direction.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((direction).value = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_el_select, _mergeProps(field, {
                              filterable: "",
                              placeholder: "",
                              class: "w-100",
                              modelValue: direction.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((direction).value = $event))
                            }), {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ComponentDiretionOptions), (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.id,
                                    label: option.label,
                                    value: option.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1040, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (['RADIO_BUTTON', 'LIST'].includes(props.selectedComponent))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-group mb-5",
                            key: index
                          }, [
                            _createVNode(_unref(Field), {
                              class: "form-control mb-2 mb-md-0",
                              modelValue: option.text,
                              "onUpdate:modelValue": ($event: any) => ((option.text) = $event),
                              type: "text",
                              name: `label[${index}]`,
                              autocomplete: "off",
                              placeholder: "Label for Radio Button"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                            _createVNode(_unref(Field), {
                              class: "form-control pr-2 mb-md-0",
                              modelValue: option.value,
                              "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
                              type: "text",
                              name: `key[${index}]`,
                              autocomplete: "off",
                              placeholder: "Value for Radio Button"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                            _createElementVNode("span", _hoisted_15, [
                              _createElementVNode("a", {
                                class: "btn btn-icon btn-primary btn-circle mx-2",
                                onClick: _cache[6] || (_cache[6] = _withModifiers(
                        () => {
                          options.value.push({ text: '', value: '' });
                        }
                      , ["stop"]))
                              }, _hoisted_17)
                            ]),
                            (options.value.length > 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                  _createElementVNode("a", {
                                    class: "btn btn-icon btn-danger btn-circle",
                                    onClick: _withModifiers(
                        () => {
                          options.value.splice(index, 1);
                        }
                      , ["stop"])
                                  }, _hoisted_21, 8, _hoisted_19)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_unref(ErrorMessage), { name: "phoneNumber" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "showDialog"])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})